import { object } from "@/common/object.util";
import ApiAdmin from "@/services/apiAdmin.service";

import {
  FETCH_ALL,
  FETCH,
  SAVE,
  SAVE_LEAD,
  DELETE,
  CLEAR_ALL,
  DEFAULT_USUARIO,
  FETCH_ALL_GROUPS_KEYCLOAK
} from "@/store/actions/actions.type";

import {
  FETCH_ALL_START,
  SET_ALL,
  FETCH_ALL_END,
  UNSET_ALL,
  FETCH_START,
  SET,
  FETCH_END,
  DELETE_START,
  UNSET,
  DELETE_END,
  SAVE_START,
  SAVE_END,
  SET_DEFAULT_USER,
  SET_ALL_GROUPS_KEYCLOAK
} from "@/store/mutations/mutations.type";

const defaults = Object.freeze({
  defaultUsuario: {
    id: "",
    createdTimestamp: null,
    username: "",
    enabled: false,
    totp: false,
    emailVerified: false,
    firstName: "",
    lastName: "",
    email: "",
    disableableCredentialTypes: [],
    requiredActions: [],
    notBefore: 0,
    niveisAcesso: [],
    credentials: [{ value: "" }]
  },
  usuario: {
    id: "",
    createdTimestamp: null,
    username: "",
    enabled: false,
    totp: false,
    emailVerified: false,
    firstName: "",
    lastName: "",
    email: "",
    disableableCredentialTypes: [],
    requiredActions: [],
    notBefore: 0,
    niveisAcesso: [],
    credentials: [{ value: "" }]
  },
  groups: {
    data: []
  },
  usuarios: {
    current_page: 1,
    per_page: 10,
    data: []
  }
});

const state = {
  groups: object.clone(defaults.groups),
  usuarios: object.clone(defaults.usuarios),
  isFetchingUsuario: false,
  isFetchingUsuarios: false,
  isSavingUsuarios: false,
  isDeletingUsuario: false,
  usuario: object.clone(defaults.usuario),
  usuarioOriginal: object.clone(defaults.usuario),
  deletingId: null
};
const getters = {
  usuario(state) {
    return state.usuario;
  },
  usuarios(state) {
    return state.usuarios;
  },
  groups(state) {
    return state.groups;
  },
  isFetchingUsuario(state) {
    return state.isFetchingUsuario;
  },
  isFetchingUsuarios(state) {
    return state.isFetchingUsuarios;
  },
  isSavingUsuarios(state) {
    return state.isSavingUsuarios;
  },
  isDeletingUsuario(state) {
    return state.isDeletingUsuario;
  },
  deletingId(state) {
    return state.deletingId;
  }
};

const actions = {
  [DEFAULT_USUARIO](context, params) {
    context.commit(SET_DEFAULT_USER);
  },
  [FETCH_ALL](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(FETCH_ALL_START);

      ApiAdmin.query("keycloak/users/list", params)
        .then(response => {
          context.commit(SET_ALL, response.data);
          resolve();
        })
        .catch(e => {
          reject(e.response.data);
        })
        .finally(() => {
          context.commit(FETCH_ALL_END);
        });
    });
  },
  [FETCH_ALL_GROUPS_KEYCLOAK](context, params) {
    return new Promise((resolve, reject) => {
      ApiAdmin.query("keycloak/group/list", params)
        .then(response => {
          context.commit(SET_ALL_GROUPS_KEYCLOAK, response.data);
          resolve(response.data);
        })
        .catch(e => {
          reject(e.response.data);
        });
    });
  },
  [FETCH](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(SET, object.clone(defaults.usuario));

      if (!params) {
        resolve();
        return;
      }

      context.commit(FETCH_START);
      ApiAdmin.get("keycloak/users/get", params)
        .then(response => {
          if (response.data.id) {
            context.commit(SET, response.data);
            resolve(response.data);
          } else {
            reject({ notFound: true });
          }
        })
        .catch(e => {
          console.log(e);
          reject(false);
        })
        .finally(() => {
          context.commit(FETCH_END);
        });
    });
  },
  [SAVE](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(SAVE_START);
      ApiAdmin.post("keycloak/users/create", params)
        .then(response => {
          context.commit(SET, response.data);
          resolve(response.data);
        })
        .catch(e => {
          reject(e);
        })
        .finally(() => {
          context.commit(SAVE_END);
        });
    });
  },
  [SAVE_LEAD](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(SAVE_START);
      if (!params.isUpdate) {
        ApiAdmin.post("keycloak/users/create/lead", params)
          .then(response => {
            resolve(response.data);
          })
          .catch(e => {
            reject(e);
          })
          .finally(() => {
            context.commit(SAVE_END);
          });
      } else {
        ApiAdmin.post("keycloak/users/update/lead", params)
          .then(response => {
            resolve(response.data);
          })
          .catch(e => {
            reject(e);
          })
          .finally(() => {
            context.commit(SAVE_END);
          });
      }
    });
  },
  [DELETE](context, userIdKeycloak) {
    return new Promise((resolve, reject) => {
      ApiAdmin.delete(`keycloak/users/delete`, userIdKeycloak)
        .then(response => {
          context.commit(DELETE_START);
          resolve(response.data);
        })
        .catch(e => {
          reject(e);
        })
        .finally(() => {
          context.commit(DELETE_END);
        });
    });
  },
  [CLEAR_ALL](context) {
    return new Promise(resolve => {
      context.commit(UNSET_ALL);
      resolve();
    });
  }
};

const mutations = {
  [DELETE_START](state) {
    state.isDeletingUsuario = true;
  },
  [DELETE_END](state) {
    state.isDeletingUsuario = false;
  },
  [FETCH_ALL_START](state) {
    state.isFetchingUsuarios = true;
  },
  [SET_DEFAULT_USER](state) {
    state.usuario = object.clone(state.defaultUsuario);
  },
  [SET_ALL](state, usuarios) {
    let cloneUsuarios = usuarios;
    //parsing quando recebe um objeto no lugar de um array (ocorre as vezes com o pagination no back)
    if (!Array.isArray(usuarios.data)) {
      let arrayOfKeys = Object.keys(cloneUsuarios.data);
      let arrayFormatado = arrayOfKeys.map(key => cloneUsuarios.data[key]);
      cloneUsuarios.data = arrayFormatado;
    }
    state.usuarios = cloneUsuarios;
  },
  [FETCH_ALL_END](state) {
    state.isFetchingUsuarios = false;
  },
  [UNSET_ALL](state) {
    state.usuarios = object.clone(defaults.usuarios);
  },
  [SAVE_START](state) {
    state.isSavingUsuarios = true;
  },
  [FETCH_START](state) {
    state.isFetchingUsuario = true;
  },
  [SET](state, usuario) {
    state.usuario = usuario;
    state.usuarioOriginal = object.clone(usuario);
  },
  [FETCH_END](state) {
    state.isFetchingUsuario = false;
  },
  [SAVE_END](state) {
    state.isSavingUsuarios = false;
  },
  [SET_ALL_GROUPS_KEYCLOAK](state, groups) {
    state.groups.data = groups;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
